<template>
  <HorseTable
    :headers="headers"
    title="Historique des événements"
    :table-items="filteredSessionByType"
    class="mt-4 pr-2"
  />
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { format } from 'date-fns';
import store from '@/store';

import HorseTable from './HorseTable.vue';

import { filteredSessionPerContentType } from '../../../helpers/dataManager';

export default {
  components: { HorseTable },
  props: {
    horse: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const headers = ref([
      { text: 'Date', value: 'date', align: 'center', sortable: false },
      { text: 'Motif', value: 'activity', align: 'center', sortable: false },
      { text: 'Observation', value: 'observation', align: 'center', sortable: false }
    ]);
    const panel = ref(0);
    const references = computed(() => store.state.references);

    const filteredSessionByType = computed(() => {
      const horseSessions = filteredSessionPerContentType(props.horse, 'type', ['COMPETITION']);

      return horseSessions.map(session => ({
        date: format(new Date(session.start_time * 1000), 'dd/MM/yyyy'),
        activity: references.value.equestrian_session_values[session.type] || '--',
        observation: session.observation || '--'
      }));
    });

    return { headers, panel, filteredSessionByType };
  }
};
</script>
